import { ReactComponent as BackLeftIcon } from "src/assets/icons/back-left.svg";
import { ReactComponent as BackIcon } from "@preownedfront/lib-reowds/icons/24/arrow-left.svg";

import { FC } from "react";
import { t } from "i18next";
import { useNavigationLogic } from "../utils/useNavigationLogic";

interface ArrowBackButtonProps extends React.SVGProps<SVGSVGElement> {
  className?: string;
  noFunc?: boolean;
  isSmall?: boolean;
}

export const ArrowBackButton: FC<ArrowBackButtonProps> = ({
  className = "",
  noFunc = false,
  isSmall = false,
  ...props
}) => {
  const { handleBackClick } = useNavigationLogic();
  const Icon = isSmall ? BackIcon : BackLeftIcon;

  return (
    <button
      onClick={noFunc ? undefined : handleBackClick}
      className={`nav-zds__icons__header-icon__button ${className}`}
      aria-label={t("go_back")}
    >

      <Icon className={`nav-zds__icons__header-icon__svg ${noFunc ? "icon-hidden" : ""}`} {...props} />
    </button>
  );
};

export default ArrowBackButton;
